import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
 */
import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { ConnectedRouter } from 'connected-react-router';
import '../../lib/strings/core-strings'; // Register our (DBD) network implementation with wfui-digital-core. This ensures
// any network API calls make from wfui-digital-core will use our DBD-specific implementations

import '../../lib/network/register-network-api';
import '../../lib/navigation/register-navigation-api';
import ChildWindowRouteWatcher from 'wfui-digital-core/es/ChildWindowRouteWatcher';
import WorkingOverlayContainer from 'wfui-digital-core/es/WorkingOverlayContainer';
import ModalRoot from 'wfui-digital-core/es/ModalRoot';
import PathCleaner from 'wfui-digital-core/es/PathCleaner';
import PageContainer from 'wfui-digital-core/es/PageContainer';
import AccessibilityFocus from 'wfui-digital-core/es/AccessibilityFocus';
import AriaLiveAnnouncer from 'wfui-digital-core/es/AriaLiveAnnouncer';
import CoreSettingsProvider from 'wfui-digital-core/es/CoreSettingsProvider';
import FontSupport from 'wfui-digital-core/es/FontSupport';
import WFModalManager from 'wfui-digital-core/es/WFModalManager';
import { historyFactory, getAppContainerName, registerLogger, digitalCoreSagas } from 'wfui-digital-core/es/lib';
import coreSagas from '../../lib/store/core-sagas';
import Session from '../session/Session';
import SessionLogoffConfirmationModal from '../session/SessionLogoffConfirmationModal';
import SessionTimeoutWarningModal from '../session/SessionTimeoutWarningModal';
import StopMessageModal from '../stop-message-modal/StopMessageModal';
import NavigationConfirmationModal from '../navigation-confirmation-modal/NavigationConfirmationModal';
import DeviceFeatureConfirmationModal from '../device-feature-confirmation/DeviceFeatureConfirmationModal';
import BrandProvider from '../brand-provider/BrandProvider';
import DeviceProvider from '../device-provider/DeviceProvider';
import ContentProvider from '../content-provider/ContentProvider';
import PerformanceProvider from '../performance-provider/PerformanceProvider';
import HistoryManager from '../history-manager/HistoryManager';
import LogoffPromptWatcher from '../logoff-prompt-watcher/LogoffPromptWatcher';
import KeyboardSupport from '../keyboard-support/KeyboardSupport';
import DBDInterdictionModal from '../interdiction/InterdictionModal';
import TealiumLoader from '../tealium-loader/TealiumLoader';
import SettingsProvider from '../settings/SettingsProvider';
import WFUIBridgeContainer from '../wfui-bridge/WFUIBridgeContainer';
import ChatBotContainer from '../chat-bot/ChatBotContainer';
import NuanceContainer from '../nuance-chat/NuanceContainer';
import SuspenseOverlay from '../suspense-overlay/SuspenseOverlay';
import BiometricsEnroll from '../biometrics/BiometricsEnroll';
import FirstFocus from '../first-focus/FirstFocus';
import globals from '../../lib/globals/globals';
import { getStore } from '../../lib/store/store';
import scrollToFocus from '../../lib/scroll-to-focus/scroll-to-focus';
import * as nativeAppBridge from '../../lib/native-app-bridge/native-app-bridge';
import setNativeBreadcrumb from '../../lib/native-app-breadcrumb/set-native-breadcrumb';
import MenuProvider from '../menu-provider/MenuProvider';
import logger from '../../lib/logger/logger';
import '../../lib/framework-version/framework-version';
var DeveloperTools = /*#__PURE__*/React.lazy(function () {
  return import(
  /* webpackChunkName: "DevTools" */
  '../../developer-tools/DeveloperTools');
});
import styles from '../../styles/base.less';
var sagaMiddleware = createSagaMiddleware();

var appServices = function appServices(AppComponent) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$appReducer = _ref.appReducer,
      appReducer = _ref$appReducer === void 0 ? {} : _ref$appReducer,
      _ref$appSagas = _ref.appSagas,
      appSagas = _ref$appSagas === void 0 ? [] : _ref$appSagas,
      _ref$appMiddleware = _ref.appMiddleware,
      appMiddleware = _ref$appMiddleware === void 0 ? [] : _ref$appMiddleware;

  var WrappedApplication = function WrappedApplication() {
    var _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        store = _useState2[0],
        setStore = _useState2[1];

    useEffect(function () {
      if (!store) {
        var _store = getStore({
          appReducer: appReducer,
          appMiddleware: appMiddleware,
          sagaMiddleware: sagaMiddleware
        });

        digitalCoreSagas.map(function (saga) {
          return sagaMiddleware.run(saga);
        });
        coreSagas.map(function (saga) {
          return sagaMiddleware.run(saga);
        });
        appSagas.map(function (saga) {
          return sagaMiddleware.run(saga);
        });
        setStore(_store);
      } else {
        registerLogger(logger);
        logger.info("DBD-React-UI Framework version ".concat(globals().frameworkVersion)); // Set runtime location for asynchronously loaded JavaScript bundles
        // localServerMode should be true only when running in a local development environment

        if (!globals().localServerMode) {
          logger.debug('Setting webpack public path:', globals().webAssetsPath); // eslint-disable-next-line

          __webpack_public_path__ = globals().webAssetsPath; // NOSONAR
        } // Initialize the native application bridge API


        nativeAppBridge.initialize(window.mwfGlobals.nonce);
        logger.debug('Setting a native app breadcrumb with the pageId:', globals().pageId);
        setNativeBreadcrumb(globals().pageId); // Workaround to fix broken focus scrolling in Android

        scrollToFocus();
      }
    }, [store]);
    var sessionProps = {
      sessionTimeoutWarningInterval: globals().sessionTimeoutWarningInterval,
      sessionTimeoutInterval: globals().sessionTimeoutInterval,
      keepAlivePath: globals().keepAlivePath
    };
    return store ? /*#__PURE__*/React.createElement(PerformanceProvider, null, /*#__PURE__*/React.createElement(CoreSettingsProvider, null, /*#__PURE__*/React.createElement(SettingsProvider, null, /*#__PURE__*/React.createElement(WFModalManager, null, /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(ModalRoot, null), /*#__PURE__*/React.createElement(PathCleaner, null), /*#__PURE__*/React.createElement(AccessibilityFocus, null), /*#__PURE__*/React.createElement(Provider, {
      store: store
    }, /*#__PURE__*/React.createElement(BrandProvider, null), /*#__PURE__*/React.createElement(ContentProvider, null), /*#__PURE__*/React.createElement(DeviceProvider, null), /*#__PURE__*/React.createElement(FontSupport, null), /*#__PURE__*/React.createElement(AriaLiveAnnouncer, null), /*#__PURE__*/React.createElement(Session, sessionProps, /*#__PURE__*/React.createElement(ConnectedRouter, {
      history: historyFactory()
    }, /*#__PURE__*/React.createElement(HistoryManager, {
      appContainerName: getAppContainerName(),
      pushLandingHistory: true
    }, /*#__PURE__*/React.createElement(TealiumLoader, null), /*#__PURE__*/React.createElement(LogoffPromptWatcher, null), /*#__PURE__*/React.createElement(KeyboardSupport, null), /*#__PURE__*/React.createElement(ChildWindowRouteWatcher, null), /*#__PURE__*/React.createElement(SessionLogoffConfirmationModal, null), /*#__PURE__*/React.createElement(NavigationConfirmationModal, null), /*#__PURE__*/React.createElement(SessionTimeoutWarningModal, null), /*#__PURE__*/React.createElement(DeviceFeatureConfirmationModal, null), /*#__PURE__*/React.createElement(DBDInterdictionModal, null), /*#__PURE__*/React.createElement(StopMessageModal, null), /*#__PURE__*/React.createElement(WFUIBridgeContainer, null), /*#__PURE__*/React.createElement(ChatBotContainer, null), /*#__PURE__*/React.createElement(NuanceContainer, null), /*#__PURE__*/React.createElement("div", {
      className: styles.appWrapper
    }, /*#__PURE__*/React.createElement(FirstFocus, null), /*#__PURE__*/React.createElement(MenuProvider, null, /*#__PURE__*/React.createElement(AppComponent, null), /*#__PURE__*/React.createElement(BiometricsEnroll, null)), /*#__PURE__*/React.createElement(WorkingOverlayContainer, null)), globals().enableDevTools && /*#__PURE__*/React.createElement(React.Suspense, {
      fallback: /*#__PURE__*/React.createElement(SuspenseOverlay, null)
    }, /*#__PURE__*/React.createElement(DeveloperTools, null))))))))))) : null;
  };

  return WrappedApplication;
};

export default appServices;